// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react'
import { inject, observer } from 'mobx-react/index'
import { NavLink, useLocation, type Location } from 'react-router-dom'

import Nav from '../../../src/components/Elements/Nav'
import Logo from '../../theme/images/logo.svg'
import AppTheme from '../../../src/components/Providers/Theme'
import LoginStore from '../../store/LoginStore'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { themeDetails } from '../../theme/theme.ts'

type HeaderBaseProps = {
  location: Location,
  LoginStore: typeof LoginStore,
}

const HeaderBase = (props: HeaderBaseProps): JSX.Element => {
  const { LoginStore, location } = props
  const { logged, firstName, lastName } = LoginStore
  const onLandingPage = location.pathname === '/'

  const name = firstName + ' ' + lastName

  const waterServices = themeDetails.services.indexOf('water') > -1

  return (
    <AppTheme themeName={onLandingPage ? 'inverted' : 'default'}>
      <div className="header">
        <div className="container">
          <NavLink to="/">
            <img src={Logo} className="logo" alt="logo" />
          </NavLink>
          <div className="container__items">
            {logged && waterServices && (
              <NavLink
                to="/vesilukema"
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                Ilmoita vesilukema
              </NavLink>
            )}
            {logged && !onLandingPage && <h5>{name}</h5>}
            {logged && <Nav LoginStore={LoginStore} />}
            {!logged && !onLandingPage && (
              <NavLink className="home-link" to="/">
                Etusivu
              </NavLink>
            )}
          </div>
        </div>
      </div>
    </AppTheme>
  )
}

const InjectedHeader = inject('LoginStore')(observer(HeaderBase))

function HeaderRouteWrapper(): JSX.Element {
  const location = useLocation()
  return <InjectedHeader location={location} />
}

export default HeaderRouteWrapper
